import { Badge } from "@/components/ui/badge";
import { useEntitySchema } from "@/features/backoffice";
import { useParams, useSearchParams } from "react-router-dom";
import { EntityTable } from "../components/entity-table";
import { AdminPageLayout } from "../layout";

/**
 * One table, whichever it is.
 *
 * The route carries the table name and nothing else: the title, the columns and
 * the filters all come from the schema. `?q=` seeds the search box, so a link
 * from the global search ("voir les 143 résultats") lands pre-filtered, and
 * `?client_id=` scopes the page to one tenant.
 */
export function AdminEntityTablePage() {
  const { table = "" } = useParams<{ table: string }>();
  const [searchParams] = useSearchParams();
  const { data: schema, error } = useEntitySchema(table);

  const clientId = searchParams.get("client_id") || undefined;
  const initialSearch = searchParams.get("q") || "";

  if (error) {
    return (
      <AdminPageLayout
        title={table}
        backTo={{ label: "Explorateur", path: "/admin/explorer" }}
      >
        <div className="rounded-sm border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive">
          {(error as Error).message}
        </div>
      </AdminPageLayout>
    );
  }

  return (
    <AdminPageLayout
      title={schema?.label || table}
      backTo={{ label: "Explorateur", path: "/admin/explorer" }}
      description={
        <span className="flex flex-wrap items-center gap-2">
          <span className="font-mono text-xs">{table}</span>
          {schema?.description && <span>· {schema.description}</span>}
          {clientId && (
            <Badge variant="secondary" className="text-[10px]">
              tenant {clientId}
            </Badge>
          )}
        </span>
      }
    >
      {/* `key` on the table name: switching entity must remount, not try to
          reconcile a grid whose every column changed. */}
      <EntityTable
        key={`${table}:${clientId ?? ""}`}
        table={table}
        clientId={clientId}
        initialSearch={initialSearch}
      />
    </AdminPageLayout>
  );
}
